import { useEffect } from 'react';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { Outlet, useNavigate } from 'react-router';

import { usePromoCodeContext } from 'contexts/PromoCodeContext';
import { FEATURE_FLAG_NAMES, useAmplitudeFeatureFlag } from 'hooks/useFeatureFlag';
import { STICKY_SHOP_NAVIGATION_STYLES } from 'hooks/useStickyShopNavigation';
import useTailwindTheme from 'hooks/useTailwindTheme';
import { trackExistingUserRedirect } from 'utils/analyticsUtils';
import { getSignupLocalStorage, removeSignupLocalStorage } from 'utils/signupUtils';

export default function AccountCreationLayout() {
    const { renderSignupNanoBanner } = usePromoCodeContext();
    const navigate = useNavigate();

    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });
    const onMembershipStep = window.location.pathname === '/join/membership';

    const { variantAssignment } = useAmplitudeFeatureFlag({
        flagName: FEATURE_FLAG_NAMES.PREF_QUIZ_BACK_TEST,
    });

    useEffect(() => {
        if (!variantAssignment) return;

        const storage = getSignupLocalStorage();

        const storageLooksLikeVariantA = !!(
            storage?.dietaryPreference ||
            storage?.whoAreYouShoppingFor ||
            storage?.whatDoYouBuy ||
            storage?.percentOrganic
        );
        const storageLooksLikeNotVariantA = !!(
            storage?.diet ||
            storage?.additionalPreferences ||
            typeof storage?.organicPreferences !== 'undefined' ||
            storage?.aisleSelection ||
            typeof storage?.householdSize !== 'undefined' ||
            typeof storage?.cookingFrequency !== 'undefined'
        );

        if (!storageLooksLikeVariantA && !storageLooksLikeNotVariantA) return;

        const currentIsVariantA = variantAssignment === 'variant-a';
        const storageIsVariantA = storageLooksLikeVariantA && !storageLooksLikeNotVariantA;
        const storageIsNotVariantA = storageLooksLikeNotVariantA && !storageLooksLikeVariantA;

        const mismatch = (currentIsVariantA && storageIsNotVariantA) || (!currentIsVariantA && storageIsVariantA);

        if (mismatch) {
            trackExistingUserRedirect({ destination: '/join' });
            removeSignupLocalStorage();
            navigate('/join');
        }
    }, [variantAssignment]);

    return (
        <>
            <main
                className={clsx('mx-auto flex max-w-screen-md flex-col px-25', {
                    [STICKY_SHOP_NAVIGATION_STYLES.paddingTopSignupNanobanner]: renderSignupNanoBanner,
                    [STICKY_SHOP_NAVIGATION_STYLES.paddingTopSignupNoNanobanner]: !renderSignupNanoBanner,
                    'py-0': onMembershipStep,
                    'py-25': !onMembershipStep,
                })}
            >
                <Outlet />
            </main>
            {!mobile && onMembershipStep && (
                <img
                    src="https://img-cdn.misfitsmarket.com/boysenberry/plusmembership/blueberries-desktop.png"
                    alt=""
                    className="fixed bottom-0 z-[-1] w-fit"
                />
            )}
        </>
    );
}
